import React from 'react';
import { DashboardWidget } from './widget';

export const DashboardPage: React.FC = () => <DashboardWidget />;
